import {SET_USER_DATA, RESET_USER_PHOTO, SET_NOTIFICATIONS, READ_NOTIFICATIONS} from "../constants/user";

const initialState = {
  email: null,
  birthday: null,
  first_name: null,
  last_name: null,
  phone_number: null,
  slug: null,
  payment_service: null,
  lang: null,
  sex: null,
  photo: null,
  about: null,
  living_place: null,
  avatar32: null,

  agree_sale_90: null,
  agree_sale_60: null,
  agree_sale_30_45: null,
  sell_all_once: null,
  is_sale: null,
  is_country_coefficient: null,
  yandex_saved_payment_id: null,
  paypal_subscription_id: null,

  full_name: null,
  invite_link: null,
  views_count: 0,
  registration_date: null,
  notifications: []
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        ...action.data,
      };
    case RESET_USER_PHOTO:
      return {
        ...state,
        photo: null,
      };
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.list,
      };
    case READ_NOTIFICATIONS:
      return {
        ...state,
        notifications: state.notifications.map(n => {if (action.ids.includes(n.id)) n.read=true; return n}),
      };
    default:
      return state;
  }
};

export default userReducer;